import ButtonIconStyled from "../../styles/icons/buttons";
import theme from "../../styles/theme";

const PhoneButtonIcon = () => (
	<ButtonIconStyled>
		<svg fill="none" viewBox="0 0 24 24" style={{ width: "24px" }}>
			<path
				fill={theme.purple}
				d="M14.05 6A5 5 0 0 1 18 9.95M14.05 2A9 9 0 0 1 22 9.94M18.5 21C9.94 21 3 14.06 3 5.5q0-.58.042-1.148c.032-.435.048-.653.162-.851a1.06 1.06 0 0 1 .432-.402C3.842 3 4.082 3 4.562 3h2.817c.404 0 .606 0 .779.066a1 1 0 0 1 .396.278c.122.14.191.33.329.71l1.166 3.206c.16.442.24.662.227.872a1 1 0 0 1-.182.513c-.121.171-.323.292-.725.534L8 10a12.1 12.1 0 0 0 6 6l.821-1.369c.242-.402.363-.604.534-.725a1 1 0 0 1 .513-.182c.21-.014.43.066.872.227l3.207 1.166c.38.138.569.207.709.329a1 1 0 0 1 .277.396c.067.173.067.375.067.779v2.817c0 .48 0 .72-.1.926a1.06 1.06 0 0 1-.401.432c-.198.114-.416.13-.85.162Q19.078 21 18.5 21"
			/>
		</svg>
	</ButtonIconStyled>
);

export default PhoneButtonIcon;
